import { render, staticRenderFns } from "./WorkspaceColumns.vue?vue&type=template&id=d45a9a04&"
import script from "./WorkspaceColumns.vue?vue&type=script&lang=js&"
export * from "./WorkspaceColumns.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceColumns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports